const userAgent = navigator.userAgent.toLowerCase();
export const isIOS = userAgent.includes('iphone') || userAgent.includes('ipad') || userAgent.includes('ipod');
export const isAndroid = userAgent.includes('android');
export const isWindows = userAgent.includes('windows');
export const isMac = userAgent.includes('mac') && !isIOS;
export const isLinux = userAgent.includes('linux') && !isAndroid;
